@if (order$ | async; as order) {
  @if (order) {
    <div class="total-header">
      <div>
        @if (order.code) {
          <div class="code">{{ order.code }}</div>
        }
        @if (order.created) {
          <span class="date">от &emsp; {{ order.created | date: 'dd MMMM yyyy' }}</span>
        }
      </div>
      <div class="payment" [ngClass]="order.paymentStatusInfo?.code">
        {{ order.paymentStatusInfo?.name || order.paymentStatus }}
      </div>
    </div>
    @if (order.status) {
      <sd-order-status-label
        class="status-label"
        [text]="order.statusDisplay"
        [code]="order.status"
      ></sd-order-status-label>
    }

    <!-- Если приходит разные доставки в каждой позиции, показываем разные типы -->

    @let obs =
      {
        orderEntries: orderEntries$ | async,
        showDividedDelivery: showDividedDelivery$ | async,
      };
    @if (obs.showDividedDelivery || obs.orderEntries?.length > 0) {
      @for (item of orderEntries$ | async; track item) {
        @if (item.deliveryType.type === 'delivery' && item.deliveryType.delivery.address) {
          <div
            (click)="switchDeliveryFilter(item.deliveryType.type, item.deliveryType.delivery.address)"
            class="item"
            [class]="obs.orderEntries?.length > 1 ? 'link-hover-orange pointer' : ''"
          >
            <span class="item-title">Доставка:</span>
            <span class="item-value">
              {{ item.deliveryType.delivery.deliveryDate | date: 'dd.MM.yyyy' }}, c
              {{ item.deliveryType.delivery.timeInterval.from }} до {{ item.deliveryType.delivery.timeInterval.to }},
              {{ item.deliveryType.delivery.address }}
            </span>
          </div>
        }

        @if (item.deliveryType.type === 'pickup' && item.deliveryType.pickup.address) {
          <div (click)="switchDeliveryFilter(item.deliveryType.type, item.deliveryType.pickup.address)" class="item">
            <div class="item-pickup" [class]="obs.orderEntries?.length > 1 ? 'link-hover-orange pointer' : ''">
              <span class="item-title">Самовывоз:</span>
              <span class="item-value">{{ item.deliveryType.pickup.address }}</span>
            </div>
            @if (item.deliveryType.pickup.scheme) {
              <div>
                <button
                  type="button"
                  (click)="openScheme(item.deliveryType.pickup.scheme, item.entry)"
                  class="scheme-btn"
                >
                  Схема проезда по складу
                </button>
              </div>
            }
          </div>
        }
      }
    }

    <!-- Иначе показываем общую по заказу -->
    @else {
      @if (order?.deliveryMode?.name && order.deliveryMode?.address) {
        <div class="item">
          <span class="item-title">{{ order.deliveryMode.name }}:</span>
          <span class="item-value">
            {{ order.deliveryMode?.address }}
          </span>

          @if (order.orderReceiveDate) {
            <div class="order-receive-date">
              <span class="item-title">
                {{ order.orderReceiveDate.text ? order.orderReceiveDate.text : order.orderReceiveDate }}
              </span>
              @if (order.orderReceiveDate) {
                <span class="item-value">
                  {{ order.orderReceiveDate.dateFormattedValue }}
                </span>
              }
            </div>
          }

          @if (
            order.deliveryMode.code === 'pickup' &&
            order.status !== orderStatus.CLOSED &&
            order.status !== orderStatus.CANCELLED &&
            order?.scheme
          ) {
            <div>
              <button type="button" (click)="openScheme(order.scheme, order.entries)" class="scheme-btn">
                Схема проезда по складу
              </button>
            </div>
          }
        </div>
      }
    }
  }
}
